module.exports = __webpack_public_path__ + "fonts/warning.svg";